import type {
  ContactOrderAppointmentRow,
  ContactOrderPlanningRowPresentation,
} from "../../../_logic/contact-orders-contract"
import { contactOrderPlanningRowIsCompleted } from "../_shared/_logic/customer-information-state"

export const contactOrderPlanningPresentationAllowsInteraction = (
  presentation: ContactOrderPlanningRowPresentation | null | undefined,
) => !presentation?.disabled && presentation?.selectable !== false

export const contactOrderPlanningEventAllowsInteraction = (
  eventId: string,
  presentationByEventId: Record<string, ContactOrderPlanningRowPresentation>,
) => contactOrderPlanningPresentationAllowsInteraction(presentationByEventId[eventId])

export const contactOrderPlanningRowAllowsInteraction = (
  row: ContactOrderAppointmentRow,
  presentationByEventId: Record<string, ContactOrderPlanningRowPresentation>,
) =>
  contactOrderPlanningEventAllowsInteraction(row.event.id, presentationByEventId) &&
  !contactOrderPlanningRowIsCompleted(row)

export const pruneContactOrderPlanningSelectedIds = ({
  selectedIds,
  visibleRows,
  presentationByEventId,
}: {
  selectedIds: readonly string[]
  visibleRows: ContactOrderAppointmentRow[]
  presentationByEventId: Record<string, ContactOrderPlanningRowPresentation>
}) => {
  const selectableIds = new Set(
    visibleRows
      .filter(
        (row) =>
          !row.removed && contactOrderPlanningRowAllowsInteraction(row, presentationByEventId),
      )
      .map((row) => String(row.id)),
  )

  return selectedIds.filter((id) => selectableIds.has(id))
}
